import moment from 'moment';
import { useState } from 'react';

interface Props<OtpIdType> {
  initialOtpId?: OtpIdType | null;
}

interface ReturnProps<OtpIdType> {
  lastOtpId: OtpIdType | null;
  sendNewCodeDate: Date;
  updateOtpId: (otpId: OtpIdType) => void;
  updateSendNewCodeDate: () => void;
}

const useVerifyOtp = <OtpIdType>({
  initialOtpId = null,
}: Props<OtpIdType> = {}): ReturnProps<OtpIdType> => {
  const [lastOtpId, setLastOtpId] = useState<OtpIdType | null>(
    initialOtpId ?? null
  );

  const getSendNewCodeUnblockDate = (): Date =>
    moment().add(59, 'seconds').toDate();

  const [sendNewCodeDate, setSendNewCodeDate] = useState(
    getSendNewCodeUnblockDate()
  );

  return {
    lastOtpId,
    sendNewCodeDate,
    updateOtpId: (otpId: OtpIdType) => {
      setLastOtpId(otpId);
      setSendNewCodeDate(getSendNewCodeUnblockDate());
    },
    updateSendNewCodeDate: () => {
      setSendNewCodeDate(getSendNewCodeUnblockDate());
    },
  };
};

export default useVerifyOtp;
